import { Alert } from 'antd'
import sortBy from 'lodash/sortBy'
import type { JSX } from 'react'

import { roleCanHoldCapability } from '../roleChanges'

import { CapabilitySearchModal } from './CapabilitySearchModal'

import { RoleVisibility } from 'api/capabilities'
import { Capability } from 'api/clients'

const VISIBILITY_NOTES: Partial<Record<RoleVisibility, string>> = {
  [RoleVisibility.ADMIN]: 'An admin role can hold only admin and global capabilities.',
  [RoleVisibility.PUBLIC]: 'A client role cannot hold admin or global capabilities.',
}

type AddRoleCapabilityModalProps = {
  capabilities: Capability[]
  existingCapabilities: Capability[]
  isError: boolean
  isLoading: boolean
  onAdd: (capability: Capability) => void
  onClose: () => void
  roleVisibility: RoleVisibility
}

export function AddRoleCapabilityModal({
  capabilities,
  existingCapabilities,
  isError,
  isLoading,
  onAdd,
  onClose,
  roleVisibility,
}: AddRoleCapabilityModalProps): JSX.Element {
  const existingNames = new Set(existingCapabilities.map((capability) => capability.name))
  const selectableCapabilities = sortBy(capabilities, 'name').filter(
    (capability) => !existingNames.has(capability.name) && roleCanHoldCapability(roleVisibility, capability.name),
  )
  const visibilityNote = VISIBILITY_NOTES[roleVisibility]

  return (
    <CapabilitySearchModal
      capabilities={selectableCapabilities}
      isError={isError}
      isLoading={isLoading}
      notice={visibilityNote && <Alert message={visibilityNote} showIcon type="info" />}
      onAdd={onAdd}
      onClose={onClose}
    />
  )
}
